import apiClient from './api'

export interface ApiKey {
  id: string
  name: string
  key_prefix: string
  scopes: string[]
  is_active: boolean
  expires_at: string | null
  last_used_at: string | null
  created_at: string
}

export interface ApiKeyCreated extends ApiKey {
  raw_key: string
}

export interface ScopeOption {
  scope: string
  description: string
  group: string
}

export interface ApiKeyCreate {
  name: string
  scopes: string[]
  expires_in_days?: number
}

export const apiKeyService = {
  list: async (): Promise<{ items: ApiKey[]; total: number }> => {
    const response = await apiClient.get('/admin/api-keys')
    return response.data
  },

  availableScopes: async (): Promise<{ scopes: ScopeOption[]; total: number }> => {
    const response = await apiClient.get('/admin/api-keys/available-scopes')
    return response.data
  },

  create: async (payload: ApiKeyCreate): Promise<ApiKeyCreated> => {
    const response = await apiClient.post('/admin/api-keys', payload)
    return response.data
  },

  rotate: async (id: string): Promise<ApiKeyCreated> => {
    const response = await apiClient.post(`/admin/api-keys/${id}/rotate`)
    return response.data
  },

  revoke: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/api-keys/${id}`)
  }
}

export default apiKeyService
